/*eslint-disable*/
import cities from '../../config/cities.json'

export function getPreviousLocation (location) {
    return cities[cities.indexOf(location) - 1] || 'Moscow';
}